// const jweixin = require('jweixin-module')
import store from './../store'

// console.log(this);
// shareConfiguration()

export async function shareConfiguration(shareObj) {
  let {
    jweixin,
    wstitle,
    wsdesc,
    wslink,
    wsimg,
    sucFunc,
    failFunc,
    noYes
  } = shareObj
  wstitle = wstitle || '家慧库'
  wsdesc = wsdesc || '家慧库 线上家庭知识分享平台'
  wslink = wslink || location.href
  wsimg = wsimg || require('./../assets/logo_200.png')

  // console.log(wslink, 'wslink')
  if (!noYes) {
    let url = wslink.split('?')
    if (url.length > 1) {
      let url2 = url[1].split('&')
      let parameters = '?'
      for (const item of url2) {
        if (
          item.indexOf('userId') == -1 &&
          item.indexOf('joinTraderId') == -1 &&
          item.indexOf('code') == -1 &&
          item.indexOf('registerSource') == -1
        ) {
          parameters += item + '&'
        }
      }
      wslink = url[0] + parameters
    } else {
      wslink += '?'
    }
    let userInfo = store.state.user.userInfo
    // console.log(userInfo.length)
    if (typeof userInfo.id != 'undefined') {
      wslink = wslink + 'userId=' + userInfo.id + '&joinTraderId=' + userInfo.id
    }
  }
  // console.log(wslink, 'wslink')

  jweixin.ready(function() {
    // console.log(func)
    // 分享到朋友圈
    jweixin.onMenuShareTimeline({
      title: wstitle,
      link: wslink,
      imgUrl: wsimg,
      success: function() {
        if (sucFunc) {
          sucFunc()
        }
      },
      cancel: function() {
        if (failFunc) {
          failFunc()
        }
      }
    })

    // 分享给朋友
    jweixin.onMenuShareAppMessage({
      title: wstitle,
      desc: wsdesc,
      link: wslink,
      imgUrl: wsimg,
      success: function() {
        if (sucFunc) {
          sucFunc()
        }
      },
      cancel: function() {
        if (failFunc) {
          failFunc()
        }
      }
    })

    // 分享到QQ
    jweixin.onMenuShareQQ({
      title: wstitle,
      desc: wsdesc,
      link: wslink,
      imgUrl: wsimg,
      success: function() {
        if (sucFunc) {
          sucFunc()
        }
      },
      cancel: function() {
        if (failFunc) {
          failFunc()
        }
      }
    })

    // 微信到腾讯微博
    jweixin.onMenuShareWeibo({
      title: wstitle,
      desc: wsdesc,
      link: wslink,
      imgUrl: wsimg,
      success: function() {
        if (sucFunc) {
          sucFunc()
        }
      },
      cancel: function() {
        if (failFunc) {
          failFunc()
        }
      }
    })

    // 分享到QQ空间
    jweixin.onMenuShareQZone({
      title: wstitle,
      desc: wsdesc,
      link: wslink,
      imgUrl: wsimg,
      success: function() {
        if (sucFunc) {
          sucFunc()
        }
      },
      cancel: function() {
        if (failFunc) {
          failFunc()
        }
      }
    })
  })
}
